module.exports = __webpack_public_path__ + "static/redime-tus-puntos-1-CL-f1156f60e40455313b3dd2bfab27af53.webp";